import App from "app";
import dataVisualizations from "core/services/metadataService/dataVisualizations";
import "./string";

App.module("Dashboard.VisEditor", function (VisEditor, App, Backbone, Marionette, $, _) {
    VisEditor[dataVisualizations.EDITOR.NUMBER] = VisEditor[dataVisualizations.EDITOR.STRING].extend({
        templateHTML: '<input type="number" name="{{ editor.attribute }}" placeholder="{{ editor.options ? editor.options.placeholder : ""}}"/>',
    });
});
